import React from 'react'
import {RouteWithPermission} from '../../../../_helper/routesWithPermission'
import {Switch} from 'react-router-dom'
import {hasPermission} from '../../../../_helper/hasPermission'
import {permissions} from '../../../../_constants/permissions'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
// Speech Therapy Components
import DeletedSpeechTherapyAssessmentList from '../../../pages/deleted-notes/Speech_Therapy/list/DeletedSpeechTherapyAssessmentList'
import DeletedSpeechTherapyNotes from '../../../pages/deleted-notes/Speech_Therapy/list/DeletedSpeechTherapyNotes'
import SpeechTherapyAssessmentForm from '../../../pages/deleted-notes/Speech_Therapy/form/SpeechTherapyAssessmentForm'
import SpeechTherapyNoteForm from '../../../pages/deleted-notes/Speech_Therapy/form/SpeechTherapyNoteForm'

// Caregiver Notes Components
import DeletedCaregiverNotesList from '../../../pages/deleted-notes/Caregiver_notes/list/DeletedCaregiverNotesList'
import DeletedCaregiverAssessmentList from '../../../pages/deleted-notes/Caregiver_notes/list/DeletedCaregiverNotesAssessmentList'
import DeletedCaregiverNotesAssessmentForm from '../../../pages/deleted-notes/Caregiver_notes/form/DeletedCaregiverNotesAssessmentForm'
import DeletedCaregiverNoteForm from '../../../pages/deleted-notes/Caregiver_notes/form/DeletedCaregiverNoteForm'

// Nurses Notes Components
import DeletedNursesNotesList from '../../../pages/deleted-notes/Nurses_notes/list/DeletedNursesNotesList'
import DeletedNursesAssessmentList from '../../../pages/deleted-notes/Nurses_notes/list/DeletedNursesAssessmentList'
import DeletedNursesNoteForm from '../../../pages/deleted-notes/Nurses_notes/form/DeletedNursesNoteForm'
import DeletedNursesAssessmentForm from '../../../pages/deleted-notes/Nurses_notes/form/DeletedNursesAssessmentForm'

import DeletedOTAssessmentList from '../../../pages/deleted-notes/Occupational_Therapy/list/DeletedOTAssesmentList'
import OccupationalTherapyAssesmentForm from '../../../pages/deleted-notes/Occupational_Therapy/form/OccupationalTherapyAssesmentForm'
import DeletedOccupationalTherapyNotes from '../../../pages/deleted-notes/Occupational_Therapy/list/DeletedOccupationalTherapyNotes'
import OccupationalTherapyNoteForm from '../../../pages/deleted-notes/Occupational_Therapy/form/OccupationalTherapyNoteForm'
import DeletedBehaviourAssesmentList from '../../../pages/deleted-notes/Behaviour/list/DeletedBehaviourAssesmentList'
import BehaviourAssesmentForm from '../../../pages/deleted-notes/Behaviour/form/BehaviourAssesmentForm'
import DeletedBehaviourNote from '../../../pages/deleted-notes/Behaviour/list/DeletedBehaviourNote'
import BehaviourAssesmentNoteForm from '../../../pages/deleted-notes/Behaviour/form/BehaviourAssesmentNoteForm'
import DeletedWoundCareList from '../../../pages/deleted-notes/Wound_Care/list/DeletedWoundCarelist'
import WoundCareListForm from '../../../pages/deleted-notes/Wound_Care/form/WoundCareListForm'
import DeletedWoundCareNote from '../../../pages/deleted-notes/Wound_Care/list/DeletedWoundCareNote'
import WoundCareNoteForm from '../../../pages/deleted-notes/Wound_Care/form/WoundCareNoteForm'

// Physical Therapist Notes Components
import DeletedPhysicalTherapistNotesList from '../../../pages/deleted-notes/Physical_Therapist_Notes/list/DeletedPhysicalTherapistNotesList'
import DeletedPhysicalAssessmentList from '../../../pages/deleted-notes/Physical_Therapist_Notes/list/DeletedPhysicalAssessmentList'
import DeletedPhysicalTherapistNoteForm from '../../../pages/deleted-notes/Physical_Therapist_Notes/form/DeletedPhysicalTherapistNoteForm'
import DeletedPhysicalAssessmentForm from '../../../pages/deleted-notes/Physical_Therapist_Notes/form/DeletedPhysicalAssessmentForm'

// Permissions



const DeletedAssessmentNotes = () => {

const userPermissions = useSelector((state: RootState) => state.auth.user.roleId)
const hasSpeechTherapyPermission = hasPermission(userPermissions,permissions.notes_speech_therapy_note_delete)
const hasCaregiverPermission = hasPermission(userPermissions, permissions.care_giver_notes_note_delete)
const hasNursesPermission = hasPermission(userPermissions, permissions.notes_nurses_note_entry_delete)
const hasOTPermission = hasPermission(userPermissions, permissions.notes_occupational_therapy_note_delete)
const hasBehaviourPermission = hasPermission(userPermissions, permissions.notes_behavior_note_entry_delete)
const hasWoundCarePermission = hasPermission(userPermissions, permissions.wound_care_delete)
const hasPhysicalTherapistPermission = hasPermission(userPermissions, permissions.notes_physical_therapist_note_entry_delete)


  return (
    <Switch>
      {/* Speech Therapy Routes */}
      <RouteWithPermission
        path='/deleted-notes/speech-therapy-notes/entry/list/:id'
        component={DeletedSpeechTherapyNotes}
        hasPerm={hasSpeechTherapyPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/speech-therapy-notes/entry/:id'
        component={SpeechTherapyNoteForm}
        hasPerm={hasSpeechTherapyPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/speech-therapy-notes/list'
        component={DeletedSpeechTherapyAssessmentList}
        hasPerm={hasSpeechTherapyPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/speech-therapy-notes/:id'
        component={SpeechTherapyAssessmentForm}
        hasPerm={hasSpeechTherapyPermission}
      />

      {/* Caregiver Notes Routes */}
      <RouteWithPermission
        path='/deleted-notes/caregiver-notes/notesEntries/entry/:id'
        component={DeletedCaregiverNoteForm}
        hasPerm={hasCaregiverPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/caregiver-notes/notesEntries/:id'
        component={DeletedCaregiverNotesList}
        hasPerm={hasCaregiverPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/caregiver-notes/list'
        component={DeletedCaregiverAssessmentList}
        hasPerm={hasCaregiverPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/caregiver-notes/:id'
        component={DeletedCaregiverNotesAssessmentForm}
        hasPerm={hasCaregiverPermission}
      />

      {/* Nurses Notes Routes */}
      <RouteWithPermission
        path='/deleted-notes/nurses-notes/list/noteEntries/:id'
        component={DeletedNursesNotesList}
        hasPerm={hasNursesPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/nurses-notes/noteEntries/entry/:id'
        component={DeletedNursesNoteForm}
        hasPerm={hasNursesPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/nurses-notes/list'
        component={DeletedNursesAssessmentList}
        hasPerm={hasNursesPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/nurses-notes/:id'
        component={DeletedNursesAssessmentForm}
        hasPerm={hasNursesPermission}
      />

      {/* OT Notes Routes */}
      <RouteWithPermission
        path='/deleted-notes/occupational-therapy-notes/entry/list/:id'
        component={DeletedOccupationalTherapyNotes}
        hasPerm={hasOTPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/occupational-therapy-notes/entry/:id'
        component={OccupationalTherapyNoteForm}
        hasPerm={hasOTPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/occupational-therapy-notes/list'
        component={DeletedOTAssessmentList}
        hasPerm={hasOTPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/occupational-therapy-notes/:id'
        component={OccupationalTherapyAssesmentForm}
        hasPerm={hasOTPermission}
      />

      {/* Behavior Notes Routes */}
      <RouteWithPermission
        path='/deleted-notes/behaviour-notes/entry/list/:id/:clientId/:noteType'
        component={DeletedBehaviourNote}
        hasPerm={hasBehaviourPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/behaviour-notes/entry/:id'
        component={BehaviourAssesmentNoteForm}
        hasPerm={hasBehaviourPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/behaviour-notes/list'
        component={DeletedBehaviourAssesmentList}
        hasPerm={hasBehaviourPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/behaviour-notes/:id'
        component={BehaviourAssesmentForm}
        hasPerm={hasBehaviourPermission}
      />

      {/* WoundCare Notes Routes */}
      <RouteWithPermission
        path='/deleted-notes/wound-care-notes/entry/list/:clientId/:id'
        component={DeletedWoundCareNote}
        hasPerm={hasWoundCarePermission}
      />
      <RouteWithPermission
        path='/deleted-notes/wound-care-notes/entry/:clientId/:woundId/:entryId'
        component={WoundCareNoteForm}
        hasPerm={hasWoundCarePermission}
      />
      <RouteWithPermission
        path='/deleted-notes/wound-care-notes/list'
        component={DeletedWoundCareList}
        hasPerm={hasWoundCarePermission}
      />
      <RouteWithPermission
        path='/deleted-notes/wound-care-notes/:id'
        component={WoundCareListForm}
        hasPerm={hasWoundCarePermission}
      />

      {/* Physical Therapist Notes Routes */}
      <RouteWithPermission
        path='/deleted-notes/physical-therapist-notes/notesEntries/entry/:id'
        component={DeletedPhysicalTherapistNoteForm}
        hasPerm={hasPhysicalTherapistPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/physical-therapist-notes/notesEntries/:id'
        component={DeletedPhysicalTherapistNotesList}
        hasPerm={hasPhysicalTherapistPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/physical-therapist-notes/list'
        component={DeletedPhysicalAssessmentList}
        hasPerm={hasPhysicalTherapistPermission}
      />
      <RouteWithPermission
        path='/deleted-notes/physical-therapist-notes/:id'
        component={DeletedPhysicalAssessmentForm}
        hasPerm={hasPhysicalTherapistPermission}
      />
    </Switch>
  )
}

export default DeletedAssessmentNotes
